<template>
    <div class="apk-download-container">
      <h1>Download APK Files</h1>
      <p class="subtitle">Select the version you need from the options below and click Download APK button</p>
      
      <div class="options-grid">
        <div 
          v-for="option in cities" 
          :key="option.value"
          class="option-card"
          :class="{ 'selected': selectedOption === option.value }"
          @click="selectOption(option)"
        >
          <div class="option-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 3H14C14.5523 3 15 3.44772 15 4V8H19C19.5523 8 20 8.44772 20 9V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H10ZM12 11L8 15H11V21H13V15H16L12 11ZM10 3V5H14V3H10Z"></path>
            </svg>
          </div>
          <h3>{{ option.label }}</h3>
          <p>{{ option.description }}</p>
        </div>
      </div>
      
      <button 
        class="download-button"
        :disabled="!selectedOption"
        @click="downloadApk"
      >
        Download APK
        <span v-if="isDownloading" class="spinner"></span>
      </button>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
    </div>
  </template>
  
  <script setup>
import customizationService from '@/services/customizationService';
import spinnerService from '@/services/spinnerService';
import { apiConfig } from '@/utils/config';
import { onMounted, ref } from 'vue'

 const selectedOption = ref(null);
 const selectedLabel = ref(null);
  const  isDownloading = ref( false);
  const    error = ref(null);
 const cities = ref([]);
 const selectOption = (option) =>{
      selectedOption.value = option.value;
      selectedLabel.value = option.label;
      error.value = null
    };

 const downloadApk = async ()=>{
    spinnerService.show();
    isDownloading.value = true;
    try {
        const response = await fetch(`${apiConfig.baseUrl}att/get-scanner/${selectedOption.value}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        })
        
        if (!response.ok) {
          throw new Error(`Server returned ${response.status}`)
        }
        
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${selectedLabel.value?.toLowerCase()}_scannner.apk`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        a.remove()
        
      } catch (err) {
        error.value = 'Failed to download APK. Please try again later.'
        console.error('Download error:', err)
      } finally {
        isDownloading.value = false
        spinnerService.hide();
      }
 }

 onMounted(()=>{
    cities.value = customizationService.getMunicipalitiesByDistrict(process.env.VUE_APP_DISTRICT);
 });
  </script>
  
  <style scoped>
  .apk-download-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 2rem;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  
  h1 {
    color: #2c3e50;
    margin-bottom: 0.5rem;
  }
  
  .subtitle {
    color: #7f8c8d;
    margin-bottom: 2rem;
  }
  
  .options-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .option-card {
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    padding: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: white;
  }
  
  .option-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    border-color: #fe3232;
  }
  
  .option-card.selected {
    border-color: #fe4221;
    background-color: #f8fafc;
  }
  
  .option-icon {
    width: 50px;
    height: 50px;
    margin: 0 auto 1rem;
    color: #f72f2f;
  }
  
  .option-card h3 {
    margin: 0 0 0.5rem;
    color: #2c3e50;
  }
  
  .option-card p {
    margin: 0;
    color: #7f8c8d;
    font-size: 0.9rem;
  }
  
  .download-button {
    background-color: #f83022;
    color: white;
    border: none;
    padding: 0.8rem 2rem;
    font-size: 1rem;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    min-width: 200px;
  }
  
  .download-button:hover {
    background-color: #2980b9;
  }
  
  .download-button:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
  
  .spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  .error-message {
    color: #e74c3c;
    margin-top: 1rem;
    padding: 0.5rem;
    background-color: #fadbd8;
    border-radius: 5px;
    display: inline-block;
  }
  </style>